import { PDFViewer, StyleSheet } from "@react-pdf/renderer";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import { BuildAppointPDF } from "./DocuAppointSections";
import { useEffect, useState } from "react";
import { BuildInvoicePDF, BuildReceiptPDF } from "./InvoiceBill";
import BuildPayDFBill from "./PayDFBill";
import BillingNoteBuilder from "./BillingNoteBuilder";

export const FormDocuType = {
  INVOICE: 1,
  RECEIPT: 2,
  APPOINT: 3,
  BILLING_NOTE: 4,
  PAY_DF_RAD: 5,
};

export default function BillViewer(props) {
  const { size, title, items } = props;
  const [bill, setBill] = props.billViewer;
  const [pdf, setPdf] = useState();
  const [loading, setLoading] = useState(false);

  // console.log(props.data);
  const [data, setData] = props.data;
  const { study } = props;

  useEffect(() => {
    if (bill?.show && data) {
      setLoading(true);
      console.log("Data to Pdf", data);
      // if (data?.Study) {
      buildPdf();
      // }
    }
    return () => {
      setPdf(null);
      // console.log("Bill closed....");
    };
  }, [data, bill?.show]);

  useEffect(() => {
    console.log(loading);
  }, [loading]);

  const buildPdf = async () => {
    if (!bill.formDocuType) {
      return;
      setLoading(false);
    }

    switch (bill.formDocuType) {
      case FormDocuType.APPOINT:
        await BuildAppointPDF([pdf, setPdf, data]);
        break;
      case FormDocuType.INVOICE:
        await BuildInvoicePDF([pdf, setPdf, data]);
        break;

      case FormDocuType.RECEIPT:
        await BuildReceiptPDF([pdf, setPdf, data, study]);
        break;

      case FormDocuType.PAY_DF_RAD:
        await BuildPayDFBill({ pdf, setPdf, data, items });
        break;

      case FormDocuType.BILLING_NOTE:
        BillingNoteBuilder({ pdf, setPdf, data, items });
        break;
      default:
        await BuildInvoicePDF([pdf, setPdf, data]);
        break;
    }
    setLoading(false);
  };

  const handleClose = () => {
    setBill((pv) => ({ ...pv, show: false }));
  };
  return (
    <MyModal
      show={bill?.show ?? false}
      size={size ?? "xl"}
      //   fullscreen
      centered
    >
      <ModalHeaderBlack closeButton onHide={handleClose}>
        {title ?? "PDF"}
      </ModalHeaderBlack>

      <ModalBodyBlack
        style={{ height: `${window.screen.availHeight * 0.8}px` }}
      >
        {/* <PDFViewer style={styles.container}>{bill?.document}</PDFViewer> */}
        <PDFViewer style={styles.container}>{pdf}</PDFViewer>
      </ModalBodyBlack>
    </MyModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "99%",
    height: "99%",
    marginHorizontal: 0,
  },
});
